var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCriticalAsset20CurrentColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    fill: "currentColor",
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.221.113a.2.2 0 0 0-.18-.111h-.084a.2.2 0 0 0-.179.111L7.242 5.24a.2.2 0 0 0 .18.288h5.156a.2.2 0 0 0 .179-.288L10.221.113Zm4.36 5.304a.2.2 0 0 0 .18.111h4.917a.2.2 0 0 0 .18-.288l-2.01-4.07a2.077 2.077 0 0 0-1.86-1.168h-3.764a.2.2 0 0 0-.179.289l2.536 5.126Zm4.894 2.016a.2.2 0 0 0-.155-.328h-8.347a.2.2 0 0 0-.2.2v10.138a.2.2 0 0 0 .355.127l8.347-10.137ZM8.87 17.57a.2.2 0 0 0 .354-.127V7.305a.2.2 0 0 0-.2-.2H.677a.2.2 0 0 0-.154.328L8.87 17.57ZM5.24 5.528a.2.2 0 0 0 .179-.111L7.945.29a.2.2 0 0 0-.18-.288H4.013c-.79 0-1.507.453-1.86 1.168L.142 5.24a.2.2 0 0 0 .18.288h4.917Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalAsset20CurrentColor);
export default __webpack_public_path__ + "static/media/critical-asset-20-currentColor.3300fe7ca2132dfaba9a93f8dc8dbd6e.svg";
export { ForwardRef as ReactComponent };